export const edgeTagEvent = (eventName: string, payload?: any) => {
  if (window && window.edgetag) {
    if (payload) {
      window.edgetag('tag', eventName, payload)
    } else {
      window.edgetag('tag', eventName)
    }
  }
}

export const edgeTagProductView = (productMap, variantId) => {
  const product = productMap.byVariantId[variantId]
  const product_id = product?.productId?.decoded
  const item_price = product?.pricing?.oneTime.price
  const title = product?.title
  const image = product?.image
  const quantity = 1
  const productUrl = `${window.location.origin}/products/${product?.slug}`
  const payload = {
    currency: 'USD',
    value: item_price,
    contents: [{ id: product_id, quantity, item_price, title, image, url: productUrl }]
  }

  if (window && window.edgetag) {
    window.edgetag('tag', 'ViewContent', payload)
  }
}

export const edgeTagAddToCart = (
  productMap: any,
  variantId: string,
  quantity: number,
  unitPrice: number,
  checkoutUrl: string
) => {
  const product = productMap.byVariantId[variantId]
  const product_id = product.productId.decoded
  const item_price = unitPrice
  const title = product.title
  const image = product.image
  const productUrl = `${window.location.origin}/products/${product.slug}`
  const payload = {
    currency: 'USD',
    value: item_price * quantity,
    contents: [{ id: product_id, quantity, item_price, title, image, url: productUrl }],
    checkoutUrl
  }

  if (window && window.edgetag) {
    window.edgetag('tag', 'AddToCart', payload)
  }
}

export const edgeTagUserData = (payload: Record<string, any>) => {
  if (window && window.edgetag) {
    window.edgetag('data', payload)
  }
}
